import { Injectable } from '@angular/core';

import { AppLangs, Masks } from '../../models';

@Injectable({ providedIn: 'root' })
export class MasksService {
  private lang: AppLangs;

  masks: Masks;

  constructor() {
    this.lang = localStorage.getItem('lang') as AppLangs;

    this.setMasks();
  }

  private setMasks() {
    switch (this.lang) {
      case 'pt':
        this.masks = {
          document: '000.000.000-00',
          phone: '(00) 0000-0000 || (00) 0 0000-0000',
          zipCode: '00000-000',
        };
        break;

      default:
        this.masks = {
          document: '000.000.000-00',
          phone: '(00) 0000-0000 || (00) 0 0000-0000',
          zipCode: '00000-000',
        };
        break;
    }
  }
}
